import { FeatureFlag } from '@/modules/App/featureFlags'
import { useFeatureFlags } from '@/modules/App/useFeatureFlags'
import { usePermissionsStore } from '@/modules/IdentityAndAccess/permissionsStore'
import { Permission } from '@/modules/IdentityAndAccess/types'
import { useUser } from '@/modules/IdentityAndAccess/useUser'
import type { PartialRecord } from '@/shared/types'
import { type Ref } from 'vue'

const ALL_PERMISSIONS_ENABLED = Object.values(Permission).reduce<PartialRecord<Permission, true>>(
  (acc, permission) => {
    return { ...acc, [permission]: true }
  },
  {},
)

export const useLoadProjectPermissions = ({
  rootProjectId,
  workspaceId,
}: {
  workspaceId: Ref<string>
  rootProjectId: Ref<string>
}) => {
  const permissionsStore = usePermissionsStore()
  const userStore = useUser()

  const godMode = useFeatureFlags(FeatureFlag.ENABLE_ALL_FRONTEND_ACTIONS)

  const loadProjectPermissions = async () => {
    const newProjectId = rootProjectId.value
    const newWorkspaceId = workspaceId.value
    const userId = userStore.user?.id
    const isInGodMode = godMode.value

    if (!userId) {
      return
    }

    permissionsStore.currentProjectId = newProjectId

    if (isInGodMode) {
      Object.keys(permissionsStore.resourcePermissions).forEach((projectId) => {
        permissionsStore.resourcePermissions[projectId] = ALL_PERMISSIONS_ENABLED
      })
      permissionsStore.workspacePermissions = ALL_PERMISSIONS_ENABLED
    } else {
      await permissionsStore.loadProjectPermissions({
        projectId: newProjectId,
        userId,
        workspaceId: newWorkspaceId,
      })
    }
  }

  return { loadProjectPermissions }
}
